export { default } from "./SubjectListingTextTile";
